var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_loader"},[_c('img',{attrs:{"src":"/img/loading.svg","width":"91","height":"107","alt":"Loader","title":"Loader"}})])
}]

export { render, staticRenderFns }